function PasswordRegCheck(event) {
    var passLength = document.getElementById("passLength");
    var passUpperAndLower = document.getElementById("passUpperAndLower");
    var passLettersAndNumbers = document.getElementById("passLettersAndNumbers");
    var passSpecialCharacters = document.getElementById("passSpecialCharacters");
    var passMatch = document.getElementById("passMatchPassword");
    var matchPassword = document.getElementById("inputConfirmPassword").value;
    var passString = document.getElementById("inputPassword").value;
    var passRequirements = document.getElementById("passRequirements")

    passRequirements.style.display = "block";
    //passLength.style.display = "block";
    //passUpperAndLower.style.display = "block";
    //passLettersAndNumbers.style.display = "block";
    //passSpecialCharacters.style.display = "block";
    //passMatch.style.display = "block";
    var regex=/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

    //Password Length Requirement
    if (passString.length >= 8) {
        passLength.style.color = "green";
        passLength.innerHTML = "✓ Password must be at least 8 characters."
    }
    else {
        passLength.style.color = "red";
        passLength.innerHTML = "✕ Password must be at least 8 characters."
    }

 

    //Password Uppercase and Lowercase Requirement
    if (/[A-Z]/.test(passString) && /[a-z]/.test(passString)){
        passUpperAndLower.style.color = "green";
        passUpperAndLower.innerHTML = "✓ Password must be a combination of uppercase and lowercase letters.";
    }
    else{
        passUpperAndLower.style.color = "red";
        passUpperAndLower.innerHTML = "✕ Password must be a combination of uppercase and lowercase letters.";
    }

 

    //Password Letters and Numbers Requirement
    if (passString.search(/[0-9]/) > 0){
        passLettersAndNumbers.style.color = "green";
        passLettersAndNumbers.innerHTML = "✓ Password must be a combination of letters and numbers.";
    }
    else{
        passLettersAndNumbers.style.color = "red";
        passLettersAndNumbers.innerHTML = "✕ Password must be a combination of letters and numbers.";
    }

    //Password Atleast One Special Character Requirement
    if (regex.test(passString)){
        passSpecialCharacters.style.color = "green";
        passSpecialCharacters.innerHTML = "✓ Password must have atleast one (1) special character (# ? ! + &).";
    }
    else{
        passSpecialCharacters.style.color = "red";
        passSpecialCharacters.innerHTML = "✕ Password must have atleast one (1) special character (# ? ! + &).";
    }
    if(matchPassword === passString){
        passMatch.style.color="green";
        passMatch.innerHTML="✓ Password must match.";
    }else{
        passMatch.style.color = "red";
        passMatch.innerHTML="✕ Password must match.";
    }

    if(passLength.style.color==="red"|| passUpperAndLower.style.color==="red"||
    passLettersAndNumbers.style.color==="red"||passSpecialCharacters.style.color==="red" 
    || passMatch.style.color==="red"){
       return false;
    }else{
       return true;
    }
}

export default PasswordRegCheck;